export { default as I18nProvider } from './provider.js';
export { LOCALES } from './locales';